// document.querySelector('#real').addEventListener('input', function() {
//   document.querySelector('#fake').value = this.value;
// });

$('.pw-details-list').on('click', function() {
  $(this).removeAttr('open');
});

$(document).ready(function() {
  $('.pw-details-list_list_item_link').on('click', function() {
    $(this).parents('.pw-details-list').removeAttr('open');
  });
});

$('.js-tab_control').on('click', function() {
  var id = '#' + $(this).data('target');
  $(this).addClass('--active');
  $(this).siblings().removeClass('--active');
  $(id).addClass('--active');
  $(id).siblings().removeClass('--active');
})

document.querySelectorAll('.pw-add-payment-method_switcher input').forEach(function(item, _index) {
  item.addEventListener('change', function(item, index) {
    let id = '#' + this.value;
    document.querySelectorAll('.pw-add-payment-method_form_item').forEach(function(item, _index) {
      item.classList.toggle('--active');
    });
  })
})

document.querySelectorAll('.pw-alert_button').forEach(function(item) {
  item.addEventListener('click', function() {
    this.parentElement.style.display = 'none';
  })
});

document.querySelectorAll('span.input-error').forEach(function(item) {
  item.parentElement.parentElement.classList.add('error');
});

document.querySelectorAll('.pw-tabs_nav-item').forEach(function(item, _index) {
  item.addEventListener('click', toggleTab(item, _index))
})

function toggleTab(tabControl, tabControlIndex) {
  tabControl.addEventListener('click', function() {
    this.parentNode.querySelectorAll('.pw-tabs_nav-item').forEach(function(item) {
      item.classList.remove('--active');
      item.setAttribute('tabindex', 0);
    });

    this.classList.add('--active');
    this.setAttribute('tabindex', -1);

    let tabs = this.parentElement.nextElementSibling.querySelectorAll('.pw-tabs_body_tab');
    tabs.forEach(function(tab, i) {
      if (i != tabControlIndex) tab.classList.remove('--active');
      else tab.classList.add('--active');
    })
  })
}
